var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-textarea-wrapper"},[_c('textarea',{class:{
      'f-textarea': true,
      'form-control': true,
      'is-valid': _vm.state !== 'invalid',
      'is-invalid': _vm.state === 'invalid',
      'full-width': _vm.fullWidth
    },attrs:{"id":_vm.id,"aria-invalid":_vm.state === 'invalid',"aria-required":_vm.required ? true : null,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"required":_vm.required,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),_vm._v(" "),(_vm.maxLength)?_c('span',{staticClass:"f-textarea-counter"},[_vm._v(" "+_vm._s(_vm.value && _vm.value.length ? _vm.value.length : 0)+" / "+_vm._s(_vm.maxLength)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }